import { render, staticRenderFns } from "./zhineng.vue?vue&type=template&id=379ed400&scoped=true&"
import script from "./zhineng.vue?vue&type=script&lang=js&"
export * from "./zhineng.vue?vue&type=script&lang=js&"
import style0 from "./zhineng.vue?vue&type=style&index=0&id=379ed400&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "379ed400",
  null
  
)

export default component.exports